import { UserManagementPage } from '@frontend/features/admin/components/UserManagementPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/')({
  component: UserManagementPage,
});
